import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import _ from 'lodash'

import config from '../../../../../../../../../config'

import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'
import Tabs from '../../../../../../../../../components/Tabs'

import WonTenders from './components/WonTenders'
import AssignedTenders from './components/AssignedTenders'

import { LOCALE_PREFIX } from './constants'

import './styles.scss'

@hocBlock(config.modules.report.key, { levelReload: true })
@injectIntl
export default class Procurement extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        data: PropTypes.object,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        level: PropTypes.string,
        locale: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
    }

    render() {
        const {
            id,
            module,
            block,
            level,
            locale,
            customData,
            data,
            intl: { formatMessage },
        } = this.props

        return (
            <div className={'public-tenders-block-container'}>
                <Tabs
                    level={level}
                    id={`negative-events-tabs-${id}`}
                    key={`negative-events-tabs-${id}`}
                    tabs={[
                        {
                            // Won tenders (vyhrané veřejné zakázky, supplied)
                            title: formatMessage({ id: `${LOCALE_PREFIX}.wonPublicTenders` }),
                            content: (
                                <WonTenders
                                    summary={data?.suppliedSummary}
                                    module={module}
                                    block={block}
                                    level={level}
                                    locale={locale}
                                    id={id}
                                    customData={customData}
                                    locked={_.isNil(data?.suppliedSummary?.count)}
                                />
                            ),
                            subtitle: formatMessage({ id: `${LOCALE_PREFIX}.wonSlashJoined` }),
                            counter: {
                                left: {
                                    count: data?.suppliedSummary?.count ?? 0,
                                },
                            },
                        },
                        {
                            title: formatMessage({ id: `${LOCALE_PREFIX}.assignedPublicTenders` }),
                            content: (
                                // Assigned tenders (zadané veřejné zakázky, published)
                                <AssignedTenders
                                    summary={data?.publishedSummary}
                                    module={module}
                                    block={block}
                                    level={level}
                                    locale={locale}
                                    id={id}
                                    customData={customData}
                                    locked={_.isNil(data?.publishedSummary?.count)}
                                />
                            ),
                            subtitle: formatMessage({ id: `${LOCALE_PREFIX}.assigned` }),
                            counter: {
                                left: {
                                    count: data?.publishedSummary?.count ?? 0,
                                },
                            },
                        },
                    ]}
                />
            </div>
        )
    }
}
